<div id="managePopUp" *ngIf="!showDefaultAddressPopup">
  <div class="modal-header">
    <span class='modal-title'>{{authoringContentData?.accountDetailsTab?.editPassword}}</span>
    <button type="button" class="close" aria-label="Close" (click)="closePopupTagging()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div>
      <p class="headerPart">{{authoringContentData?.accountDetailsTab?.editPINSubheader}} {{banNumber}} ({{banName}}).
      </p>
    </div>
    <div class="row">
      <!--Current Pin-->
      <mat-form-field class="currentPIN" floatLabel="never">
        <mat-label class="PinLabel">{{authoringContentData?.accountDetailsTab?.currentPIN}}</mat-label>
        <input type='password' matInput [(ngModel)]="currentPassword" (focusout)="currentPinFocusOut(currentPassword)">
      </mat-form-field>
      <p class=" forgotPinText">{{authoringContentData?.accountDetailsTab?.forgotPINtext}}</p>
      <!--New Pin-->
      <mat-form-field class="currentPIN" floatLabel="never">
        <mat-label class="PinLabel" [ngClass]="{'error': incorrectPAssword == true || editAction ==true}">
          {{authoringContentData?.accountDetailsTab?.newPIN}}</mat-label>
        <input type='password' maxlength='15' matInput [(ngModel)]="inputText" (focusout)="onFocusOut(inputText)"
          (cut)="preventAction()" (copy)="preventAction()" (paste)="preventAction()">
      </mat-form-field>
      <p class='optional_text' [ngClass]="{'error': incorrectPAssword == true}" *ngIf="!editAction">
        {{authoringContentData?.accountDetailsTab?.PINvalidationText}}<span class="optional_errortext"
          *ngIf="incorrectPAssword"></span></p>
      <p class='optional_texts' *ngIf="editAction">{{authoringContentData?.accountDetailsTab?.ignoreCopyPaste}}<span
          class="optional_errortexts"></span></p>
      <!--Confirm Pin-->
      <mat-form-field class="currentPIN" floatLabel="never">
        <mat-label class="PinLabel" [ngClass]="{'error': confirmPwdFlag == false ||allowAction== true }">
          {{authoringContentData?.accountDetailsTab?.confirmPIN}}</mat-label>
        <input type='password' [disabled]="disableConfirmPAssword" maxlength='15' [(ngModel)]="confirmedPassword"
          (focusout)="onConfirmPwd(confirmedPassword)" matInput (cut)="preventActionforConfirmPassword()"
          (copy)="preventActionforConfirmPassword()" (paste)="preventActionforConfirmPassword()">
      </mat-form-field>
      <p class='optional_texts' *ngIf="confirmPwdFlag == false && allowAction == false">
        {{authoringContentData?.accountDetailsTab?.passwordNotMatched}}<span class="optional_error"></span></p>
      <p class='optional_texts' *ngIf="allowAction">{{authoringContentData?.accountDetailsTab?.ignoreCopyPaste}}<span
          class="optional_errortexts"></span></p>
    </div>
  </div>
  <div clas="row" *ngIf="isEditPwdInlineError">
    <div class="col-xs-12">
      <div class="center_box">
        <div class="alert_box">
          <div class="alert_txt">
            <span class="alert_icon"></span>{{errorMessage}}
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="w-100 modal-footer justify-content-end">
    <div class="footer-button">
          <button type='button' (click)="cancelPopupTagging()"
              class='secondary_btn'>{{authoringContentData?.accountDetailsTab?.cancelBtn}}</button>
            </div>
    <div class="footer-button">
        <button type='button' (click)="accountPasswordChange()" [disabled]="disableConfirmPinBtn || issubmitReadOnly"
      class='primary_btn'>{{authoringContentData?.accountDetailsTab?.ChangePinBtn}}</button>
    </div>
  </div>
</div>

<div id="managePopUp" *ngIf="showDefaultAddressPopup">
  <div class="modal-header">
    <span class='modal-title'>{{authoringContentData?.accountDetailsTab?.editHeader}}</span>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <div>
      <p class="headerPart">{{authoringContentData?.accountDetailsTab?.editSubheader}}</p>      
      <div class="row">
        <div class="col-md-6 mt-4">
          <div class="input-floating-wrapper">
            <input tabindex="0" type="text" id="billing_addr_name" required="" disabled="" [value]=name
              (change)="continueButtonEnabled = true">
            <label class="floating-label">{{authoringContentData?.accountDetailsTab?.name}}</label>
          </div>
        </div>
        <div class="col-md-6"></div>
      </div>
      <div class="row">
        <div class="col-6 mt-4">
          <div class="input-floating-wrapper">
            <input type="text" id="billing_address1" [value]=banAddressPrimary required=""
              [(ngModel)]="banAddressPrimary" (change)="continueButtonEnabled = true"> <label
              class="floating-label">{{authoringContentData?.accountDetailsTab?.addressLine1Text}}</label>
            <p class="optional_text optional_errortext" id="billing_address1_error" style="display: none;"></p>
          </div>
        </div>
        <div class="col-6 mt-4">
          <div class="input-floating-wrapper">
            <input type="text" id="billing_address2" required="" [value]=banAddressOptional
              [(ngModel)]="banAddressOptional" (change)="continueButtonEnabled = true">
            <label class="floating-label">{{authoringContentData?.accountDetailsTab?.addressLine2Text}}</label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-6 mt-4">
          <div class="input-floating-wrapper" floatLabel='never'>
            <input type="text" id="billing_addr_city" required [value]=city [(ngModel)]="city"
              (change)="continueButtonEnabled = true">
            <label class="floating-label">{{authoringContentData?.accountDetailsTab?.city}}</label>
          </div>
        </div>
        <div class="col-3 mt-4">
          <div class="input-floating-wrapper">
            <div class="custom_select open_select">
              <label class="floating-label">{{authoringContentData?.accountDetailsTab?.state}}</label>
              <mat-form-field class="w100" floatLabel='never'>
                <mat-select placeholder={{state}} [(ngModel)]="state"
                  (selectionChange)="continueButtonEnabled = true">
                  <mat-option *ngFor="let reason of stateOptions" [value]="reason">
                    {{reason}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </div>
        <div class="col-3 mt-4">
          <div class="input-floating-wrapper" floatLabel='never'>
            <input type="text" id="billing_addr_zip" maxlength="6" required [value]=zipCode [(ngModel)]="zipCode" (change)="onZipChange()"
              floatLabel='never'> <label class="floating-label"
              floatLabel='never'>{{authoringContentData?.accountDetailsTab?.zip}}</label>
            <p class="npaErrorMsg small-text d-flex text-danger" *ngIf="zipCode?.length < 5" id="billing_addr_zip_error">{{authoringContentData?.accountDetailsTab?.invalidZipText}}</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer pull-right">
    <div class="footer-button">
      <button type='button' (click)="closeModal()"
        class='secondary_btn'>{{authoringContentData?.accountDetailsTab?.cancelBtn}}</button>
    </div>
    <div class="footer-button">
      <button type='button' [disabled]="!continueButtonEnabled || billAddressReadOnly" (click)="openSuccessModel()"
        class='primary_btn'>{{authoringContentData?.accountDetailsTab?.useAddressText}}</button>
    </div>
  </div>
</div>
